<template>
  <div class="flex justify-center h-full bg-white">
    <div class="flex flex-col message-block-width mt-24px">
      <h2 class="text-lg h-28px px-24px">全部通知</h2>
      <div class="h-65px px-24px pt-14px pb-0 flex text-center clear-both">
        <div class="flex-1">
          <el-tabs id="tab-pane" v-model="activeTabName">
            <el-tab-pane label="未读" name="unRead"></el-tab-pane>
            <el-tab-pane label="已读" name="readed"></el-tab-pane>
          </el-tabs>
        </div>
        <div v-show="activeTabName === 'unRead'" class="relative m-auto">
          <el-link type="primary" @click="allMarkRead">一键已读</el-link>
        </div>
      </div>
      <div v-if="showList.length > 0" class="px-24px pt-24px overflow-y-scroll">
        <MessageItem v-for="item in showList" :key="item.id" :message="item" :activeTabName="activeTabName" />
        <div class="flex justify-center">
          <el-button
            v-if="showList && showList.length > 0 && hasMoreMessage"
            type="text"
            :loading="dataLoading"
            class="mt-0 mb-24px"
            @click="showMore"
          >
            查看更多
          </el-button>
        </div>
      </div>
      <div v-else class="flex justify-center items-center h-200px">
        <cat-empty class="mt-200px" title="暂无消息通知" iconType="custom">
          <template #icon>
            <img class="w-6em h-6em" src="@/assets/defaultImg/img_message@2x.png" />
          </template>
          <template #tip>
            <span class="text-xs">还没有数据</span>
          </template>
        </cat-empty>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MessageItem from './components/messageItem.vue';

const messageStore = useSysMessageStore();
const { unReadList, readedList, unReadTotal, readedTotal } = storeToRefs(messageStore);
const { loadMoreReadedMessage, loadMoreUnReadMessage, allMarkRead } = messageStore;

const activeTabName = ref<string>('unRead');
const showList = computed(() => {
  return activeTabName.value === 'unRead' ? unReadList.value : readedList.value;
});

const currentTotal = computed(() => {
  return activeTabName.value === 'unRead' ? unReadTotal.value : readedTotal.value;
});

const dataLoading = ref<boolean>(false);

const tmpMessageCount = ref<number | null>(null);
const messageCount = ref<number | null>(null);
const hasMoreMessage = computed(() => {
  return showList.value?.length < currentTotal.value;
  // if (messageCount.value && tmpMessageCount.value) {
  //   return messageCount.value !== tmpMessageCount.value;
  // } else {
  //   return true;
  // }
});
async function showMore() {
  dataLoading.value = true;
  tmpMessageCount.value = messageCount.value;
  switch (activeTabName.value) {
    case 'unRead':
      await loadMoreUnReadMessage();
      break;
    case 'readed':
      await loadMoreReadedMessage();
      break;
    default:
      break;
  }
  messageCount.value = showList.value.length;
  dataLoading.value = false;
}

const route = useRoute();
onMounted(() => {
  activeTabName.value = route.query.readStatus === '1' ? 'readed' : 'unRead';
});
</script>

<style scoped lang="scss">
:deep #tab-pane .el-tabs__nav .el-tabs__item {
  padding-left: 0 !important;
}

.message-block-width {
  width: 35vw;
  min-width: 632px;
  max-width: 1000px;
}
</style>

<route lang="yaml">
meta:
  layout: detail
</route>
